<template>
  <div class="project-details project-opertion">
    <el-form
      class="project-details-from"
      :rules="projectOpertionFromRules"
      ref="projectOpertionFrom"
      :model="projectOpertionFrom"
      label-width="100px"
    >
      <p class="sub-title">税率</p>
      <div class="row">
        <el-form-item label="税率" prop="operatorTaxRate">
          <el-input
            @input="taxRateInput"
            v-model="projectOpertionFrom.operatorTaxRate"
            placeholder="示例：税率6%，填写0.06"
            :disabled="isFlag === 3? true:false"
          ></el-input>
        </el-form-item>
      </div>
      
      <div class="switch-title">
        <p class="sub-title">操作保底</p>
        <el-switch
          class="custom-operator-switch"
          active-color="#2E68EA"
          :disabled="isFlag === 3"
          v-model="projectOpertionFrom.guaranteedOperatePriceStatus"
          :active-text="projectOpertionFrom.guaranteedOperatePriceStatus?'开启保底':'关闭保底'"
        >
        </el-switch>
      </div>
      <div class="row" v-if="projectOpertionFrom.guaranteedOperatePriceStatus">
        <el-form-item label="操作保底" prop="guaranteedOperatePrice">
          <el-input
            class="select-minimum-guarantee"
            @input="guaranteedOperatePriceInput"
            v-model="projectOpertionFrom.guaranteedOperatePrice"
            placeholder="请输入"
            :disabled="isFlag === 3"
            :rules="[
              { required: projectOpertionFrom.guaranteedOperatePriceStatus ? true : false, message: '请输入操作保底', trigger: 'blur' }
            ]"
          >
            <span
              slot="suffix"
              >{{ guaranteedOperateUnitObj[projectOpertionFrom.guaranteedOperatePriceType] }}</span
            >
          </el-input>
          <el-select
            class="w120"
            v-model="projectOpertionFrom.guaranteedOperatePriceType"
            @change="changeGuaranteedOperatePrice"
            :disabled="isFlag === 3"
          >
            <el-option
              v-for="item in guaranteedOperatePriceList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>

      <p class="sub-title">订单分拣</p>
      <div class="row">
        <el-form-item label="计费依据" prop="chargeFoundation">
          <el-select
            v-model="projectOpertionFrom.chargeFoundation"
            placeholder="请选择计费依据"
            :disabled="isFlag === 3? true:false"
          >
            <el-option
              v-for="item in chargeFoundationList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起步价格" prop="startPrice">
          <el-input
            @input="startPriceInput"
            v-model="projectOpertionFrom.startPrice"
            placeholder="请输入起步价格"
            :disabled="isFlag === 3"
          >
            <span slot="suffix">元/单</span>
          </el-input>
        </el-form-item>
        <el-form-item label="件数范围" prop="number">
          <el-input
            class="select-flag"
            @input="numberInput"
            v-model="projectOpertionFrom.number"
            :placeholder="
              !projectOpertionFrom.numberStatus ? '无需输入' : '请输入件数范围'
            "
            :disabled="isFlag === 3?true:!projectOpertionFrom.numberStatus"
          ></el-input>
          <el-select
            class="w60"
            v-model="projectOpertionFrom.numberStatus"
            @change="changeNumberStatus"
            :disabled="isFlag === 3"
          >
            <el-option
              v-for="item in disabledList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="额外费用" prop="additionalCosts">
          <el-input
            @input="additionalCostsInput"
            v-model="projectOpertionFrom.additionalCosts"
            placeholder="请输入额外费用"
            :disabled="isFlag === 3?true:!projectOpertionFrom.numberStatus"
          >
            <span slot="suffix">元/件</span>
          </el-input>
        </el-form-item>
      </div>
      
      <p class="sub-title">订单取消</p>
      <div class="row">
        <el-form-item label="订单取消价格" prop="orderCancelUnitPrice">
          <el-input
            @input="orderCancelUnitPriceInput"
            v-model="projectOpertionFrom.orderCancelUnitPrice"
            placeholder="请输入订单取消价格"
            :disabled="isFlag === 3"
          >
            <span slot="suffix">元/单</span>
          </el-input>
        </el-form-item>
      </div>

      <p class="sub-title">退货处理</p>
      <div class="row">
        <el-form-item label="退货起步价格" prop="returnStartingPrice">
          <el-input
            @input="returnStartingPriceInput"
            v-model="projectOpertionFrom.returnStartingPrice"
            placeholder="请输入价格"
            :disabled="isFlag === 3"
          >
            <span slot="suffix">元/单</span>
          </el-input>
        </el-form-item>
        <el-form-item label="超件退货价格" prop="returnPriceOfSuperParts">
          <el-input
            @input="returnPriceOfSuperPartsInput"
            v-model="projectOpertionFrom.returnPriceOfSuperParts"
            placeholder="请输入费用"
            :disabled="isFlag === 3"
          ></el-input>
        </el-form-item>
        <el-form-item label="退货件数范围" prop="rangeOfReturnedItems">
          <el-input
          class="select-flag"
            @input="rangeOfReturnedItemsInput"
            v-model="projectOpertionFrom.rangeOfReturnedItems"
            :placeholder="
              !projectOpertionFrom.rangeOfReturnedItemsStatus
                ? '无需输入'
                : '请输入范围'
            "
          :disabled="isFlag === 3?true:!projectOpertionFrom.rangeOfReturnedItemsStatus"
          ></el-input>
          <el-select
            class="w60"
            v-model="projectOpertionFrom.rangeOfReturnedItemsStatus"
            @change="changeRangeOfReturnedItemsStatus"
            :disabled="isFlag === 3"
          >
            <el-option
              v-for="item in disabledList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>

      <p class="sub-title">大宗出库</p>
      <div class="row">
        <el-form-item label="大宗出库价格" prop="bulkDeliveryPrice">
          <el-input
            @input="bulkDeliveryPriceInput"
            v-model="projectOpertionFrom.bulkDeliveryPrice"
            placeholder="请输入费用"
            :disabled="isFlag === 3"
          ></el-input>
        </el-form-item>
      </div>

      <p class="sub-title">卸货入库</p>
      <div class="row">
        <el-form-item label="卸货价格" prop="unloadingPrice">
          <el-input
            @input="unloadingPriceInput"
            v-model="projectOpertionFrom.unloadingPrice"
            placeholder="请输入费用"
            :disabled="isFlag === 3"
          ></el-input>
        </el-form-item>
      </div>

      <p class="sub-title">增值服务</p>
      <div class="borderTop">
        <div class="increment-service">
          <div class="row-item"
            v-for="(domain, index) in projectOpertionFrom.domains"
            :key="index"
          >
            <span class="sort">{{index+1}}</span>
            <div class="row-item-content">
              <el-form-item
                class="service-name"
                label="服务名称"
                :prop="'domains.' + index + '.serviceType'"
                :rules="{
                  required: true, message: '服务名称不能为空', trigger: 'blur'
                }"
              >
                <el-select
                  v-model="domain.serviceType"
                  placeholder="请选择服务名称"
                  :disabled="isFlag === 3"
                  @change="changeServiceName(index)"
                >
                  <el-option
                    v-for="item in serviceNameList"
                    :key="item.id"
                    :label="item.serviceName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="单价（元）"
                :prop="'domains.' + index + '.unitPrice'"
                :rules="{
                  required: true, message: '单价不能为空', trigger: 'blur'
                }"
              >
                <el-input
                  @input="unitPriceInput(index)"
                  v-model="domain.unitPrice"
                  placeholder="请输入金额"
                  :disabled="isFlag === 3"
                ></el-input>
                <span v-if="isFlag === 2" class="remove-domain" @click.prevent="removeDomain(domain)"></span>
              </el-form-item>
            </div>
          </div>
        </div>
        <div v-if="isFlag === 2">
          <el-button 
            type="text" 
            class="btn-text"
            @click="addDomain"
          >+添加服务</el-button>
        </div>
      </div>

    </el-form>
    <div class="project-details-footer" v-if="isFlag === 2">
      <el-button class="btn-blue" @click="saveProjectOpertion('projectOpertionFrom')">保存</el-button>
    </div>
  </div>
</template>

<script>
import ProjectManage from "models/project-manage";
const projectManage = new ProjectManage();
import { getDecimal, getInteger, getThreeDecimal } from "common/js/util";
import projectManageMixins from "@/common/mixins/project-manage.js"
export default {
  mixins: [projectManageMixins],
  props: ['parentProjectOperationFrom'],

  data() {
    return {
      isFlag: null,
      projectOpertionFrom: this.parentProjectOperationFrom,
      projectOpertionFromRules: {
        chargeFoundation: [
          { required: true, message: "请选择计费依据", trigger: "change" },
        ],
        startPrice: [
          { required: true, message: "请输入起步价", trigger: "blur" },
        ],
        orderCancelUnitPrice: [
          { required: true, message: "请输入订单取消价格", trigger: "blur" },
        ],
        returnStartingPrice: [
          { required: true, message: "请输入退货起步价格", trigger: "blur" },
        ],
        bulkDeliveryPrice: [
          { required: true, message: "请输入大宗出库价格", trigger: "blur" },
        ],
        unloadingPrice: [
          { required: true, message: "请输入卸货价格", trigger: "blur" },
        ],
        operatorTaxRate: [{ required: true, message: "请输入税率", trigger: "blur" }],
      }
    }
  },

  created() {
    this.$bus.on('projecttOperationFrom', v => {
      this.projectOpertionFrom = v
    })
    this.isFlag = Number(this.$route.query.isFlag);
    this.initServiceNameList()
  },

  methods: {
    saveProjectOpertion(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let id = Number(this.$route.query.projectId);
          let orderCancelUnitPrice = this.projectOpertionFrom.orderCancelUnitPrice
          // 订单分拣
          let chargeFoundation = this.projectOpertionFrom.chargeFoundation
          let unitPrice = this.projectOpertionFrom.startPrice
          let quantityLimit = this.projectOpertionFrom.number === "" ? 0 : Number(this.projectOpertionFrom.number)
          let excessUnitPrice = this.projectOpertionFrom.additionalCosts === "" ? 0 : Number(this.projectOpertionFrom.additionalCosts)
          let operatorCharge = {
            chargeFoundation,
            unitPrice,
            quantityLimit,
            excessUnitPrice
          } 
          // 退货处理
          let unitPriceOfReturn = this.projectOpertionFrom.returnStartingPrice
          let excessUnitPriceOfReturn = this.projectOpertionFrom.returnPriceOfSuperParts === "" ? 0 : Number(this.projectOpertionFrom.returnPriceOfSuperParts)
          let quantityLimitOfReturn = this.projectOpertionFrom.rangeOfReturnedItems === "" ? 0 : Number(this.projectOpertionFrom.rangeOfReturnedItems)
          let returnCharge = {
            unitPrice: unitPriceOfReturn,
            quantityLimit: quantityLimitOfReturn,
            excessUnitPrice: excessUnitPriceOfReturn
          }
          let guaranteedOperatePrice = this.projectOpertionFrom.guaranteedOperatePrice
          let bulkUnitPrice = this.projectOpertionFrom.bulkDeliveryPrice === "" ? 0 : Number(this.projectOpertionFrom.bulkDeliveryPrice)
          let unloadUnitPrice = this.projectOpertionFrom.unloadingPrice
          let extraServiceList = this.projectOpertionFrom.domains
          let operatorTaxRate = this.projectOpertionFrom.operatorTaxRate;
          // 操作保底
          let operateGuaranteedRule = null
          if (this.projectOpertionFrom.guaranteedOperatePriceStatus) {
            let guaranteedOperatePrice =
              this.projectOpertionFrom.guaranteedOperatePrice 
              ? this.projectOpertionFrom.guaranteedOperatePrice
                : 0;
            let ruleType = this.projectOpertionFrom.guaranteedOperatePriceType
            operateGuaranteedRule = {}
            operateGuaranteedRule.ruleType = ruleType
            if (ruleType === 'fee') {
              operateGuaranteedRule.baseAmount = guaranteedOperatePrice
            } else {
              operateGuaranteedRule.baseOrderQuantity = guaranteedOperatePrice
            }
          }
          let data = {
            id,
            orderCancelUnitPrice, 
            operatorCharge,
            guaranteedOperatePrice,
            returnCharge,
            bulkUnitPrice,
            unloadUnitPrice,
            extraServiceList,
            operatorTaxRate,
            operateGuaranteedRule
          }
          projectManage.postUpdateProjectOpertion(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '操作收入计费规则编辑成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    },

    /**
     * @desc 添加服务
     */
    addDomain() {
      this.projectOpertionFrom.domains.push({
        serviceType: null,
        serviceName: '',
        unitPrice: null
      });
    },
    removeDomain(item) {
      let index = this.projectOpertionFrom.domains.indexOf(item)
      if (index !== -1) {
        this.projectOpertionFrom.domains.splice(index, 1)
      }
    },
    changeServiceName(index) {
      let domainsObj = this.projectOpertionFrom.domains[index]
      let obj = this.serviceNameList.find(i => { return i.id == domainsObj.serviceType})
      this.projectOpertionFrom.domains[index].serviceName = obj.serviceName
    },
    changeNumberStatus() {
      if (!this.projectOpertionFrom.numberStatus) {
        this.projectOpertionFrom.number = ''
        this.projectOpertionFrom.additionalCosts = ''
      }
    },
    changeRangeOfReturnedItemsStatus() {
      if (!this.projectOpertionFrom.rangeOfReturnedItemsStatus) {
        this.projectOpertionFrom.rangeOfReturnedItems = ''
        this.projectOpertionFrom.returnPriceOfSuperParts = ''
      }
    },
    /* 起步价限制 */
    startPriceInput() {
      let startPrice = this.projectOpertionFrom.startPrice;
      this.projectOpertionFrom.startPrice = getDecimal(startPrice);
    },
    /* 订单取消价格限制 */
    orderCancelUnitPriceInput() {
      let orderCancelUnitPrice = this.projectOpertionFrom.orderCancelUnitPrice;
      this.projectOpertionFrom.orderCancelUnitPrice = getDecimal(orderCancelUnitPrice);
    },
    /* 额外费用限制 */
    additionalCostsInput() {
      let additionalCosts = this.projectOpertionFrom.additionalCosts;
      this.projectOpertionFrom.additionalCosts = getDecimal(additionalCosts);
    },
    /* 件数限制 */
    numberInput() {
      if (this.projectOpertionFrom.number > 20) {
        this.projectOpertionFrom.number = ''
        return this.$message.error('件数范围不能超过20')
      }
      let number = this.projectOpertionFrom.number;
      this.projectOpertionFrom.number = getInteger(number);
    },
    /* 操作月保底 */
    guaranteedOperatePriceInput() {
      let guaranteedOperatePrice = this.projectOpertionFrom.guaranteedOperatePrice;
      this.projectOpertionFrom.guaranteedOperatePrice = getDecimal(
        guaranteedOperatePrice
      );
    },
    /* 退货起步价格限制 */
    returnStartingPriceInput() {
      let returnStartingPrice = this.projectOpertionFrom.returnStartingPrice;
      this.projectOpertionFrom.returnStartingPrice = getDecimal(returnStartingPrice);
    },
    /* 退货件数范围限制 */
    rangeOfReturnedItemsInput() {
      let rangeOfReturnedItems = this.projectOpertionFrom.rangeOfReturnedItems;
      this.projectOpertionFrom.rangeOfReturnedItems = getDecimal(rangeOfReturnedItems);
    },
    /* 超件退货价格限制 */
    returnPriceOfSuperPartsInput() {
      let returnPriceOfSuperParts = this.projectOpertionFrom.returnPriceOfSuperParts;
      this.projectOpertionFrom.returnPriceOfSuperParts = getDecimal(
        returnPriceOfSuperParts
      );
    },
    /* 大宗出库价格限制 */
    bulkDeliveryPriceInput() {
      let bulkDeliveryPrice = this.projectOpertionFrom.bulkDeliveryPrice;
      this.projectOpertionFrom.bulkDeliveryPrice = getDecimal(bulkDeliveryPrice);
    },
    /* 卸货价格限制 */
    unloadingPriceInput() {
      let unloadingPrice = this.projectOpertionFrom.unloadingPrice;
      this.projectOpertionFrom.unloadingPrice = getDecimal(unloadingPrice);
    },
    /* 服务单价 */
    unitPriceInput(index) {
      let unitPrice = this.projectOpertionFrom.domains[index].unitPrice;
      this.projectOpertionFrom.domains[index].unitPrice = getThreeDecimal(unitPrice);
    },
    /* 限制税率 */
    taxRateInput() {
      let operatorTaxRate = this.projectOpertionFrom.operatorTaxRate;
      this.projectOpertionFrom.operatorTaxRate = getDecimal(operatorTaxRate);
    },
    /** 
     * @desc 清空操作保底金额
    */
    changeGuaranteedOperatePrice() {
      this.projectOpertionFrom.guaranteedOperatePrice = null
    },
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/project/project-details.scss';
</style>
